module.exports = __webpack_public_path__ + "static/img/view.7a2229a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/view.png
// module id = 1126
// module chunks = 37